import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Informacoes from '@/views/usuarios/Informacoes'
import Negociadores from '@/views/usuarios/Negociadores'
import Permissoes from '@/views/usuarios/Permissoes'
import Perfil from '@/views/usuarios/Perfil'
import { mapState, mapActions } from 'vuex'
import mensagens from '@/util/mensagens'
import constants from '@/util/constants'
import { BAlert } from 'bootstrap-vue'
import util from '@/util'
import cadastroUtil from '@/util/cadastroUtil'

export default {
  name: 'edicao-usuario-administracao',
  components: {
    cabecalho,
    menuLateral,
    Informacoes,
    Negociadores,
    Permissoes,
    Perfil,
    'b-alert': BAlert
  },

  computed: {
    ...mapState('usuarios', ['listaNegociadoresDoUsuario', 'possuiNegociador', 'listaPermissoesHabilitadasDoUsuario', 'listaMergeDasPermissoesDoUsuarioESistema', 'ehCoordenador', 'dadosPerfil', 'formulario', 'dadosRetorno', 'flagsDeControle']),
    ...mapState('auth', ['financeiroContratado', 'faturamentoContratado', 'relatoriosContratado'])
  },

  data: () => {
    return {
      listaPermissoesDoSistema: [],
      perfilOriginalUsuario: null,
      flagAbaInformacoes: false,
      flagAbaPermissoes: false,
      flagAbaPerfil: false,
      flagAbaNegociadores: false,
      telaDoUsuario: {
        camposAbaInformacoes: [
          'f_name',
          'f_birthday',
          'f_email',
          'f_username',
          'f_password',
          'f_password_confirm',
          'f_daysweek',
          'f_hour_begin',
          'f_hour_end',
          'f_photo.*',
          'f_office'
        ],
        camposAbaPermissoes: [
          'user_tabs',
          'f_permissions'
        ],
        camposAbaPerfil: [
          'user_profiles',
          'f_profiles',
          'f_profile_data.f_oab',
          'f_profile_data.f_coordinator',
          'f_profile_data.f_capas',
          'f_profile_data.f_profiles_clients',
          'f_profile_data.f_type',
          'f_profile_data.f_state',
          'f_profile_data.f_district',
          'f_profile_data.f_appointment_types'
        ],
        camposAbaNegociadores: [
          'agreement_users_areas'
        ]
      },
      f_photo_usuario: null
    }
  },

  async mounted () {
    this.ActionResetarDadosFormularioUsuario()
    this.ActionResetarDadosAbasCadastro()
    this.limparFlagErroNoFormulario()
    let { id } = this.$route.params

    id = this.$route.params.id
    if (!util.valorEhNulo(id)) {
      await this.obterUsuario(id)
    }
  },

  methods: {
    ...mapActions('usuarios', ['ActionResetarDadosFormularioUsuario', 'ActionResetarDadosAbasCadastro', 'ActionDefinirSePossuiNegociador', 'ActionDefinirListaPermissoesDosistema', 'ActionDefinirDadosPerfilUsuario', 'ActionDefinirDadosPerfilAdvogado']),

    async obterUsuario (id) {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const resposta = await this.axios.get('/usuarios/usuario/' + id)
        this.formulario.f_id = resposta.data.retorno.dados.f_id
        this.formulario.f_name = resposta.data.retorno.dados.f_name
        this.formulario.f_extension = resposta.data.retorno.dados.f_extension
        this.formulario.f_email = resposta.data.retorno.dados.f_email
        this.formulario.f_sede = resposta.data.retorno.dados.f_sede
        this.formulario.f_role = resposta.data.retorno.dados.f_role
        this.formulario.f_daysweek = resposta.data.retorno.dados.f_daysweek
        this.formulario.f_hour_begin = resposta.data.retorno.dados.f_hour_begin
        this.formulario.f_hour_end = resposta.data.retorno.dados.f_hour_end
        this.formulario.f_birthday = util.formatarData(resposta.data.retorno.dados.f_birthday, 'YYYY-MM-DD')
        this.formulario.f_office = cadastroUtil.mapearObjetoCombo({ campo: resposta.data.retorno.dados.office, codigo: 'f_id', label: 'f_name' })
        this.formulario.f_username = resposta.data.retorno.dados.f_username
        this.formulario.f_status = this.obterStatus(resposta.data.retorno.dados.f_status)
        this.formulario.f_coordinator = resposta.data.retorno.dados.f_coordinator
        this.formulario.f_reviewer = resposta.data.retorno.dados.f_reviewer
        this.f_photo_usuario = resposta.data.retorno.dados.f_photo
        const dadosAbasCadastro = {
          'perfis': resposta.data.retorno.dados.user_profiles,
          'negociadores': resposta.data.retorno.dados.agreement_users_areas,
          'permissoesUsuario': resposta.data.retorno.dados.user_tabs,
          'permissoesIntegracao': {
            'f_billing': resposta.data.retorno.dados.f_billing,
            'f_reports': resposta.data.retorno.dados.f_reports,
            'f_financial': resposta.data.retorno.dados.f_financial
          },
          'dadosPerfilUsuario': resposta.data.retorno.dados.f_profile_data,
          'dadosSalvosPerfilAdvogado': resposta.data.retorno.dados.f_lawyer_data
        }
        this.popularAbasDoCadastro(dadosAbasCadastro)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    async salvarRegistro () {
      if (this.checarSePerfilEraAdvogadoETrocou()) {
        this.showModalExclusaoDadosAdvogado()
      } else {
        this.executarSalvarRegistro()
      }
    },

    checarSePerfilEraAdvogadoETrocou () {
      return ((this.perfilOriginalUsuario === 1) && (this.perfilOriginalUsuario !== this.formulario.f_profiles))
    },

    showModalExclusaoDadosAdvogado () {
      this.$bvModal.msgBoxConfirm('Deseja excluir os dados do advogado?', {
        size: 'sm',
        buttonSize: 'sm',
        okTitle: 'Sim',
        okVariant: 'outline-danger',
        cancelTitle: 'Não',
        cancelVariant: 'outline-primary',
        hideHeaderClose: true,
        centered: true,
        noCloseOnEsc: true,
        noCloseOnBackdrop: true
      })
        .then(value => {
          this.dadosPerfil.f_check_previous_data = value
          this.executarSalvarRegistro()
        })
    },

    async executarSalvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        let dadosFormulario = util.mapearObjetos(this.formulario, {})
        dadosFormulario.f_birthday = util.formatarData(dadosFormulario.f_birthday)
        dadosFormulario.f_permissions = this.mapearPermissoesParaSalvar()
        dadosFormulario.f_areas = this.atribuirListaNegociadoresNaRequisicao()
        dadosFormulario.f_profiles = this.atribuirPerfilUsuarioNaRequisicao()
        dadosFormulario.f_int_permissions = this.atribuirListaPermissoesIntegracaoNaRequisicao()
        dadosFormulario.f_profile_data = this.atribuirDadosPerfilUsuarioNaRequisicao()
        dadosFormulario.f_status = this.obterStatus(dadosFormulario.f_status)
        dadosFormulario.f_office = cadastroUtil.obterCodigoCombo({ campo: dadosFormulario.f_office })
        const formData = this.montarObjetoDeEnvio(dadosFormulario)

        let resposta = await this.axios.post('/usuarios/salvar', formData)
        this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
        this.dadosRetorno.mensagem = resposta.data.retorno.mensagem
        this.dadosRetorno.listaDeErros = resposta.data.retorno.listaDeErros

        this.resetarFlagAbasDoUsuario()
        this.limparFlagErroNoFormulario()
        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const formData = new FormData()
      const campos = Object.entries(dadosFormulario)
      const fotoUsuario = ['f_photo']
      const camposListas = ['f_daysweek', 'f_profile_data', 'f_profiles', 'f_int_permissions', 'f_permissions', 'f_areas']
      const camposIgnorados = [...fotoUsuario, ...camposListas]

      for (let [chave, valor] of campos) {
        if (!camposIgnorados.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, valor)
        }

        if (fotoUsuario.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave + '[]', valor, valor.nome)
        }

        if (camposListas.includes(chave)) {
          formData.append(chave, JSON.stringify(valor))
        }
      }
      return formData
    },

    mapearPermissoesParaSalvar () {
      let permissoesHabilitadas = this.listaMergeDasPermissoesDoUsuarioESistema
      permissoesHabilitadas = permissoesHabilitadas.filter((permissao) => { return permissao.habilitada === true })
      permissoesHabilitadas = permissoesHabilitadas.map((permissaoObjOriginal) => {
        const permissaoObjAlterado = {
          'f_tab': permissaoObjOriginal.f_id
        }
        return permissaoObjAlterado
      })
      return permissoesHabilitadas
    },

    atribuirListaNegociadoresNaRequisicao () {
      let listaNegociadoresRequisicao = []
      listaNegociadoresRequisicao = this.listaNegociadoresDoUsuario
      listaNegociadoresRequisicao = listaNegociadoresRequisicao.map((negociador) => {
        const negociadorAlterado = {
          'f_area': negociador.f_id
        }
        return negociadorAlterado
      })
      return listaNegociadoresRequisicao
    },

    atribuirPerfilUsuarioNaRequisicao () {
      let listaPerfisUsuarioRequisicao = []
      if (!util.valorVazio(this.formulario.f_profiles)) {
        listaPerfisUsuarioRequisicao.push({
          'f_profile': this.formulario.f_profiles
        })
      }
      return listaPerfisUsuarioRequisicao
    },

    atribuirListaPermissoesIntegracaoNaRequisicao () {
      let listaPermissoesIntegracaoRequisicao = []
      listaPermissoesIntegracaoRequisicao = {
        'f_billing': !this.faturamentoContratado ? false : this.formulario.f_billing,
        'f_reports': !this.relatoriosContratado ? false : this.formulario.f_reports,
        'f_financial': this.formulario.f_financial
      }
      return listaPermissoesIntegracaoRequisicao
    },

    atribuirDadosPerfilUsuarioNaRequisicao () {
      let dadosPerfilDoUsuarioRequisicao = {}

      switch (this.formulario.f_profiles) {
        case 1:// Advogado
          dadosPerfilDoUsuarioRequisicao = {
            'f_oab': (util.valorVazio(this.dadosPerfil.f_oab) ? null : this.dadosPerfil.f_oab),
            'f_coordinator': (util.valorVazio(this.dadosPerfil.coordinator) ? null : this.dadosPerfil.coordinator.code),
            'f_actiontypes': this.obterTiposAcaoNaRequisicao(),
            'f_capas': this.obterCapasNaRequisicao()
          }
          break

        case 5:// Estagiario
          dadosPerfilDoUsuarioRequisicao = {
            'f_coordinator': (util.valorVazio(this.dadosPerfil.coordinator) ? null : this.dadosPerfil.coordinator.code),
            'f_capas': this.obterCapasNaRequisicao(),
            'f_check_previous_data': (util.valorVazio(this.dadosPerfil.f_check_previous_data) ? false : this.dadosPerfil.f_check_previous_data)
          }
          break

        case 3:// Cliente
          dadosPerfilDoUsuarioRequisicao = {
            'f_profiles_clients': this.obterListaClientesNaRequisicao(),
            'f_check_previous_data': (util.valorVazio(this.dadosPerfil.f_check_previous_data) ? false : this.dadosPerfil.f_check_previous_data),
            'f_appointment_types': this.obterListaTiposPrazosNaRequisicao()
          }
          break

        case 4:// Correspondente
          dadosPerfilDoUsuarioRequisicao = {
            'f_type': !util.valorVazio(this.dadosPerfil.f_type) ? this.dadosPerfil.f_type.code : null,
            'f_check_previous_data': (util.valorVazio(this.dadosPerfil.f_check_previous_data) ? false : this.dadosPerfil.f_check_previous_data)
          }
          break

        case 6:// Financeiro
          dadosPerfilDoUsuarioRequisicao = {
            'f_check_previous_data': (util.valorVazio(this.dadosPerfil.f_check_previous_data) ? false : this.dadosPerfil.f_check_previous_data)
          }
          break

        default:
          break
      }
      return dadosPerfilDoUsuarioRequisicao
    },

    obterTiposAcaoNaRequisicao () {
      let listaAcoesRequisicao = []
      let listaAcoes = this.dadosPerfil.f_actiontypes
      for (let indice in listaAcoes) {
        let acao = listaAcoes[indice]
        listaAcoesRequisicao.push({
          'f_actiontype': acao.f_actiontype
        })
      }
      return listaAcoesRequisicao
    },

    obterCapasNaRequisicao () {
      let listaCapasRequisicao = []
      let listaCapas = this.dadosPerfil.f_capas
      for (let indice in listaCapas) {
        let capa = listaCapas[indice]
        listaCapasRequisicao.push({
          'f_view': capa.f_view
        })
      }
      return listaCapasRequisicao
    },

    obterListaClientesNaRequisicao () {
      let listaClientesRequisicao = []
      let listaClientes = this.dadosPerfil.f_profiles_clients
      for (let indice in listaClientes) {
        let registro = listaClientes[indice]
        listaClientesRequisicao.push({
          'f_id': registro.f_id,
          'f_client': registro.f_client,
          'f_state': registro.f_state,
          'f_area': registro.f_area
        })
      }
      return listaClientesRequisicao
    },

    obterListaTiposPrazosNaRequisicao () {
      let listaTiposPrazosRequisicao = this.dadosPerfil.f_appointment_types.map(prazo => ({ f_appointmenttype: prazo.f_id }))
      return listaTiposPrazosRequisicao
    },

    obterStatus (status) {
      return status ? constants.statusUsuario.ativo : constants.statusUsuario.inativo
    },

    tratarAposSalvarRegistro () {
      this.flagsDeControle.avisoDeErroNoFormulario = util.obterDadosAlertaAposSalvarRegistro(this.dadosRetorno)

      if (this.flagsDeControle.avisoDeErroNoFormulario.exibir) {
        this.obterAbaDoUsuarioComErro()
        this.tratarMensagensDeErro()
      } else {
        this.$router.push({ name: 'usuarios' }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        })
      }
    },

    tratarMensagensDeErro () {
      let mensagemRetorno = this.dadosRetorno.mensagem
      let flagNegociador = this.dadosRetorno.listaDeErros.flagConfigNegociador
      let flagPermissaoFinanceiro = this.dadosRetorno.listaDeErros.flagPermissaoFinanceiro
      let flagPermissaoFaturamento = this.dadosRetorno.listaDeErros.flagPermissaoFaturamento

      if (!util.valorVazio(flagNegociador)) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno.concat('. ').concat(flagNegociador))
      }
      if (!util.valorVazio(flagPermissaoFinanceiro)) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno.concat('. ').concat(flagPermissaoFinanceiro))
      }
      if (!util.valorVazio(flagPermissaoFaturamento)) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno.concat('. ').concat(flagPermissaoFaturamento))
      }
      if ((util.valorVazio(flagNegociador)) && (util.valorVazio(flagPermissaoFinanceiro)) && (util.valorVazio(flagPermissaoFaturamento))) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno)
      }
    },

    obterAbaDoUsuarioComErro () {
      const erros = Object.entries(this.dadosRetorno.listaDeErros)

      for (let [campo] of erros) {
        if (this.telaDoUsuario.camposAbaInformacoes.indexOf(campo) !== -1) {
          this.flagAbaInformacoes = true
        }
        if (this.telaDoUsuario.camposAbaPerfil.indexOf(campo) !== -1) {
          this.flagAbaPerfil = true
        }
        if (this.telaDoUsuario.camposAbaPermissoes.indexOf(campo) !== -1) {
          this.flagAbaPermissoes = true
        }
        if (this.telaDoUsuario.camposAbaNegociadores.indexOf(campo) !== -1) {
          this.flagAbaNegociadores = true
        }
      }
    },

    resetarFlagAbasDoUsuario () {
      this.flagAbaInformacoes = false
      this.flagAbaPerfil = false
      this.flagAbaPermissoes = false
      this.flagAbaNegociadores = false
    },

    popularAbasDoCadastro (dadosAbasCadastro) {
      this.receberListaNegociadoresDoUsuario(dadosAbasCadastro.negociadores)
      this.receberListaPermissoesHabilitadasDoUsuario(dadosAbasCadastro.permissoesUsuario)
      this.receberListaPerfisDoUsuario(dadosAbasCadastro.perfis)
      this.popularDadosDoPerfilUsuario(dadosAbasCadastro.dadosPerfilUsuario)
      this.popularDadosSalvosPerfilAdvogado(dadosAbasCadastro.dadosSalvosPerfilAdvogado)
      this.verificarPermissaoDaAbaNegociador()
      this.habilitarPermissoesDoUsuarioNaListaDoSistema()
      this.receberListaPermissoesIntegracao(dadosAbasCadastro.permissoesIntegracao)
    },

    receberListaNegociadoresDoUsuario (listaNegociadores) {
      for (let indice in listaNegociadores) {
        let negociador = listaNegociadores[indice]
        this.listaNegociadoresDoUsuario.push({
          'f_id': negociador.area.f_id,
          'f_name': negociador.area.f_name
        })
      }
    },

    receberListaPermissoesHabilitadasDoUsuario (listaPermissoesUsuario) {
      for (let indice in listaPermissoesUsuario) {
        let permissao = listaPermissoesUsuario[indice]
        this.listaPermissoesHabilitadasDoUsuario.push({
          'f_id': permissao.tab.f_id,
          'f_name': permissao.tab.f_name
        })
      }
    },

    receberListaPerfisDoUsuario (listaPerfis) {
      let perfil = listaPerfis[0]

      if (!util.valorVazio(perfil)) {
        this.obterPerfilInicialUsuario(perfil)
        this.formulario.f_profiles = perfil.profile.f_id
      } else {
        this.formulario.f_profiles = []
      }
    },

    obterPerfilInicialUsuario (perfil) {
      this.perfilOriginalUsuario = perfil.profile.f_id
    },

    popularDadosDoPerfilUsuario (dadosDoPerfil) {
      if (util.valorVazio(dadosDoPerfil)) {
        this.ActionDefinirDadosPerfilUsuario([])
      } else {
        this.ActionDefinirDadosPerfilUsuario(dadosDoPerfil)
      }
    },

    popularDadosSalvosPerfilAdvogado (dadosSalvosDoPerfilAdvogado) {
      if (util.valorEhNulo(dadosSalvosDoPerfilAdvogado)) {
        this.ActionDefinirDadosPerfilAdvogado([])
      } else {
        this.ActionDefinirDadosPerfilAdvogado(dadosSalvosDoPerfilAdvogado)
      }
    },

    verificarPermissaoDaAbaNegociador () {
      let listaPermissoes = this.listaPermissoesHabilitadasDoUsuario
      if (!util.valorVazio(listaPermissoes)) {
        let temPermissao = listaPermissoes.some((permissao) => permissao.f_id === constants.permissaoAcordo.id)
        this.ActionDefinirSePossuiNegociador(temPermissao)
      }
    },

    habilitarPermissoesDoUsuarioNaListaDoSistema () {
      this.receberListaPermissoesDoSistema()
    },

    async receberListaPermissoesDoSistema () {
      try {
        this.listaPermissoesDoSistema = await this.ActionDefinirListaPermissoesDosistema()
      } catch (e) {
        this.listaPermissoesDoSistema = []
      }
      this.mergeDasPermissoesDoUsuarioEListaTodasPermissoes()
    },

    mergeDasPermissoesDoUsuarioEListaTodasPermissoes () {
      for (let i = 0; i < this.listaPermissoesDoSistema.length; i++) {
        const permissaoDoSistema = this.listaPermissoesDoSistema[i]
        let retorno = this.obterPermissoesHabilitadasDoUsuario(permissaoDoSistema)
        this.listaMergeDasPermissoesDoUsuarioESistema.push({
          'f_id': permissaoDoSistema.f_id,
          'f_name': permissaoDoSistema.f_name,
          'habilitada': retorno
        })
      }
      return this.listaMergeDasPermissoesDoUsuarioESistema
    },

    obterPermissoesHabilitadasDoUsuario (permissaoNoSistema) {
      let listaPermissaoDoUsuario = this.listaPermissoesHabilitadasDoUsuario
      const retorno = listaPermissaoDoUsuario.some((permissao) => permissao.f_id === permissaoNoSistema.f_id)

      return retorno
    },

    receberListaPermissoesIntegracao (listaPermissoesIntegracao) {
      this.formulario.f_billing = listaPermissoesIntegracao.f_billing
      this.formulario.f_reports = listaPermissoesIntegracao.f_reports
      this.checarAcessoAoFinanceiro(listaPermissoesIntegracao)
    },

    checarAcessoAoFinanceiro (listaPermissoesIntegracao) {
      let temAcesso = this.financeiroContratado
      if (!temAcesso) {
        this.formulario.f_financial = false
      } else {
        this.formulario.f_financial = listaPermissoesIntegracao.f_financial
      }
    },

    definirFlagErroNoFormulario (status, mensagem) {
      this.flagsDeControle.avisoDeErroNoFormulario.exibir = status
      this.flagsDeControle.avisoDeErroNoFormulario.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    limparFlagErroNoFormulario () {
      this.definirFlagErroNoFormulario(false, '')
    }
  }
}
